import PreviewModalPicture from './PreviewModalPicture'
export default PreviewModalPicture
